export const DEFAULT_IMAGE_URL = 'https://p.interacty.me/default-image-bg.svg'
export const DEFAULT_IMAGE_BG_WIDE_URL = 'https://p.interacty.me/default-image-bg-wide.svg'
export const DEFAULT_IMAGE_BG_BIG_URL = 'https://p.interacty.me/default-image-bg-big.svg'
export const DEFAULT_IMAGE_BG_BIG_BRIGHT_URL = 'https://p.interacty.me/default-image-bg-big-bright.svg'

export const API_URL = process.env.REACT_APP_BACKEND_URL

export const CDN_URL = API_URL.replace('api.', 'p.')
